import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResellerRequest, ResellerRequestSearch } from '../../../models/api-store/reseller/reseller.request.model';
import { ResellerResponse, ResellerResponseSearch } from '../../../models/api-store/reseller/reseller.response.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResellerService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.store.reseller;
  baseUrl: string = environment.backend.baseUrl_backend;
  url: string = this.baseUrl + this.pathUrl;

  create(request: ResellerRequest): Observable<ResellerResponse> {
    let url = this.url;
    return this.http.post<ResellerResponse>(url, request);
  }

  getEntity(id: number): Observable<ResellerResponse> {
    let url = this.url + "/" + id;
    return this.http.get<ResellerResponse>(url);
  }

  update(id: number, request: ResellerRequest): Observable<ResellerResponse> {
    let url = this.url + "/" + id;
    return this.http.put<ResellerResponse>(url, request);
  }

  delete(id: number) {
    let url = this.url + "/" + id;
    return this.http.delete<any>(url);
  }

  search(request:ResellerRequestSearch):Observable<ResellerResponseSearch>{
    let url = this.url+"/search";
    return this.http.post<ResellerResponseSearch>(url,request);
  }
}
